
<mat-toolbar color="primary">

  <mat-toolbar-row>
    <div class="row between-xs middle-xs header-row">
      <nav>
        <ul>
          <li><a mat-button routerLink="/home" routerLinkActive="active"><span class="material-icons">home</span></a></li>
          <li><a mat-button routerLink="/products" routerLinkActive="active">Products</a></li>
          <!-- <li><a mat-button routerLink="/card" routerLinkActive="active">Card</a></li> -->
          <li><a mat-button routerLink="/contact" routerLinkActive="active">Contact</a></li>
          <!-- <li><a routerLink="**" routerLinkActive="active">Not Found</a></li>
          <li><a routerLink="/demo" routerLinkActive="active">Demo</a></li> -->
        </ul>
      </nav>
      <!-- <span class="example-spacer"></span> -->
      <div>
        <a mat-button routerLink="/auth/login" class="button-login" >Login</a>
        <a routerLink='/order' mat-raised-button [matBadge]="total$ | async" matBadgePosition="after" matBadgeColor="accent">
          <mat-icon class="example-icon" aria-hidden="false" aria-label="Example user verified icon">shopping_cart</mat-icon>
        </a>
      </div>

    </div>
  </mat-toolbar-row>
</mat-toolbar>

